"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var eventHandlers_1 = require("./eventHandlers");
var Backdrop_1 = require("../Backdrop");
var helpers_1 = require("./helpers");
var Router_1 = require("../Router");
var defaults = {
    attributes: true,
    closeOnEsc: false,
};
/**
 * Extend this class to create your own modal.
 */
var Modal = /** @class */ (function () {
    /**
     * @param {string|HTMLElement} selector
     * @param {?ModalConfig} config
     */
    function Modal(selector, config) {
        if (config === void 0) { config = {}; }
        this.on = function () {
        };
        this.fire = function () {
        };
        this.modal = this.getElement(selector);
        this.accelerator = new Router_1.Accelerator();
        this.config = Object.assign({}, defaults, config);
        if (this.config.button) {
            this.setButton(this.config.button);
        }
        this.backdrop = Backdrop_1.Backdrop.getInstance();
        this.openModal = eventHandlers_1.openModal.bind(this);
        this.closeModal = eventHandlers_1.closeModal.bind(this);
        this.isModalOpen = helpers_1.isModalOpen.bind(this);
        this.on = this.accelerator.subscribe.bind(this.accelerator);
        this.fire = this.accelerator.publish.bind(this.accelerator);
        this.modal.Modal = this;
        this.addEventListeners();
    }
    Modal.prototype.addEventListeners = function () {
        var _this = this;
        this.backdrop.on('click', this.close.bind(this));
        this.on('show', this.open.bind(this));
        this.on('hide', this.close.bind(this));
        if (this.config.closeOnEsc) {
            document.addEventListener('keydown', function (e) {
                if (e.key === 'Escape') {
                    _this.fire('hide');
                }
            });
        }
        /**
         * @deprecated 1.0.0 in favor of pubsub
         */
        this.modal.addEventListener('wr-modal-show', function () { return _this.modal.Modal.open(); });
        /**
         * @deprecated 1.0.0 in favor of pubsub
         */
        this.modal.addEventListener('wr-modal-hide', function () { return _this.modal.Modal.close(); });
    };
    Modal.prototype.openFromButton = function (modal, button) {
        var _a;
        this.modal = this.getElement(modal);
        this.button = this.getElement(button);
        if (this.handleButtonClick) {
            (_a = this.button) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.handleButtonClick.bind(this));
        }
    };
    Modal.prototype.open = function () {
        this.openModal();
        this.fire('open', { Modal: this });
    };
    Modal.open = function (modal, config) {
        var ModalObj = new Modal(modal, config);
        ModalObj.open();
    };
    Modal.prototype.close = function () {
        this.closeModal();
        this.fire('close', { Modal: this });
    };
    Modal.close = function (modal, config) {
        var ModalObj = new Modal(modal, config);
        ModalObj.close();
    };
    Modal.prototype.getElement = function (selectorOrHTMLElement) {
        if (typeof selectorOrHTMLElement === 'string') {
            return document.querySelector(selectorOrHTMLElement);
        }
        return selectorOrHTMLElement;
    };
    Modal.prototype.setButton = function (button) {
        this.button = this.getElement(button);
        this.handleButtonClick = eventHandlers_1.handleButtonClick.bind(this);
        this.button.addEventListener('click', this.handleButtonClick.bind(this));
    };
    return Modal;
}());
exports.Modal = Modal;
exports.default = Modal;
//# sourceMappingURL=Modal.js.map